module.exports = __webpack_public_path__ + "static/media/Kitchen1.5ba5f227.jpg";